import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "common-layout",
  style: {"height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_location = _resolveComponent("location")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_Layfooter = _resolveComponent("Layfooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"height":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Header", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_container, { style: {"height":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { style: {"height":"100%"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu, {
                  "active-text-color": "#ffd04b",
                  "background-color": "#545c64",
                  class: "el-menu-vertical-demo",
                  "default-active": "2",
                  "text-color": "#fff",
                  router: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_sub_menu, { index: "1" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_location)
                          ]),
                          _: 1
                        }),
                        _cache[1] || (_cache[1] = _createElementVNode("span", null, "店铺信息", -1))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "/shop/shoplist/1" }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("店铺列表", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "/shop/ShopDetails/" }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("店铺介绍", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "FileConfig" }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("配送设置", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "FileConfig" }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("运费模版", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "/shop/classificationsettings/" }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("店铺分类设置", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "FileConfig" }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("店长推荐", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "FileConfig" }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("新品推荐", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, { index: "2" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_location)
                          ]),
                          _: 1
                        }),
                        _cache[9] || (_cache[9] = _createElementVNode("span", null, "商品管理", -1))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "/products/ProductsList/1" }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("我的商品", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "/products/ProductsCategory" }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("添加商品", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, { index: "3" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_location)
                          ]),
                          _: 1
                        }),
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "订单管理", -1))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "/Orders/OrderList/1" }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("订单列表", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Layfooter)
  ]))
}